import { RTKQueryTag } from 'src/common/constants';
import type { ApiResponse } from 'src/common/interfaces';
import { apiSlice } from 'src/features/api/api-slice';

import type { LeaguesData } from './weekly-leagues.types';

export const weeklyLeaguesSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getLeagues: builder.query<ApiResponse<LeaguesData>, { minimal?: boolean }>({
      query: ({ minimal = false } = {}) => ({
        url: `/leagues/statistics?minimal=${String(minimal)}`,
      }),

      providesTags: [RTKQueryTag.Leagues],
      keepUnusedDataFor: 300,
    }),

    updateLeagueStatusModal: builder.mutation<ApiResponse<void>, void>({
      query: () => ({
        url: '/leagues/status-modal',
        method: 'PUT',
      }),
      invalidatesTags: [RTKQueryTag.Leagues],
    }),

    getUserLeagueEligibility: builder.query<ApiResponse<{ hasMetCriteria: boolean; userCompletedRooms: number }>, void>(
      {
        query: () => ({
          url: '/leagues/my-league-eligibility',
        }),
        providesTags: [RTKQueryTag.Leagues],
        keepUnusedDataFor: 0,
      },
    ),
  }),
});

export const { useGetLeaguesQuery, useUpdateLeagueStatusModalMutation, useGetUserLeagueEligibilityQuery } =
  weeklyLeaguesSlice;
